import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PendingClockIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9233 3.39301C11.9233 2.84072 12.3711 2.39301 12.9233 2.39301C18.4466 2.39301 22.9233 6.86972 22.9233 12.393C22.9233 17.9163 18.4466 22.393 12.9233 22.393C12.3711 22.393 11.9233 21.9453 11.9233 21.393C11.9233 20.8407 12.3711 20.393 12.9233 20.393C17.3421 20.393 20.9233 16.8117 20.9233 12.393C20.9233 7.97429 17.3421 4.39301 12.9233 4.39301C12.3711 4.39301 11.9233 3.94529 11.9233 3.39301Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.3744 18.6422C6.72942 18.2191 7.36018 18.164 7.78324 18.519C8.48773 19.1102 9.30153 19.5783 10.1908 19.9025C10.7097 20.0916 10.9771 20.6655 10.7879 21.1844C10.5988 21.7033 10.0249 21.9707 9.50598 21.7815C8.40328 21.3797 7.38507 20.7958 6.49757 20.051C6.07452 19.696 6.01937 19.0652 6.3744 18.6422Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7883 3.60241C10.9769 4.12147 10.7091 4.69519 10.19 4.88385C9.30134 5.20683 8.48801 5.67467 7.7838 6.26653C7.36101 6.62187 6.73021 6.56719 6.37487 6.14439C6.01953 5.7216 6.07422 5.0908 6.49701 4.73546C7.38479 3.98932 8.40347 3.40516 9.50681 3.00415C10.0259 2.81549 10.5996 3.08334 10.7883 3.60241Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.63461 7.03016C6.11281 7.30648 6.27646 7.91813 6.00015 8.39632C5.54186 9.18945 5.2167 10.0679 5.05222 11.004C4.95665 11.548 4.43822 11.9115 3.89427 11.8159C3.35031 11.7204 2.98682 11.2019 3.08239 10.658C3.28791 9.48815 3.69475 8.38857 4.26846 7.3957C4.54477 6.91751 5.15642 6.75385 5.63461 7.03016Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.89427 12.9691C4.43822 12.8735 4.95665 13.237 5.05222 13.781C5.2167 14.7171 5.54186 15.5956 6.00015 16.3887C6.27646 16.8669 6.11281 17.4785 5.63461 17.7548C5.15642 18.0312 4.54477 17.8675 4.26846 17.3893C3.69475 16.3964 3.28791 15.2968 3.08239 14.127C2.98682 13.5831 3.35031 13.0646 3.89427 12.9691Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6414 7.379C13.1936 7.379 13.6414 7.82671 13.6414 8.379V12.4685L16.8179 14.4052C17.2895 14.6927 17.4387 15.308 17.1512 15.7796C16.8637 16.2511 16.2483 16.4003 15.7768 16.1128L12.1208 13.8838C11.823 13.7023 11.6414 13.3787 11.6414 13.03V8.379C11.6414 7.82671 12.0891 7.379 12.6414 7.379Z"
            />
        </SvgIcon>
    );
};

export default PendingClockIcon;
